import timeClockService from 'Services/api/timeClock.service'
import { TimeClockInfoContract, TimeClockType } from 'models'
import { useCallback, useState } from 'react'
import { fetchWithNotification } from 'store/actions/base.action'

const useTimeClockState = () => {
    const [timeClock, setTimeClock] = useState<
        TimeClockInfoContract | undefined
    >(undefined)
    const [loading, setLoading] = useState(false)

    const getCurrentUserTimeClock = useCallback(async () => {
        try {
            setLoading(true)
            const result = (
                await fetchWithNotification({
                    apiLinkFnc: () =>
                        timeClockService.getCurrentUserTimeClock(),
                })
            ).data
            setTimeClock(result)
        } catch {
            // TODO: We don't need this after POS-6890
        } finally {
            setLoading(false)
        }
    }, [])

    const saveActionOfUserTimeClock = useCallback(
        async (clockType: TimeClockType) => {
            try {
                setLoading(true)
                const result = (
                    await fetchWithNotification({
                        apiLinkFnc: () =>
                            timeClockService.createCurrentUserTimeClock({
                                clockType,
                            }),
                    })
                ).data
                setTimeClock(result)
            } catch {
                // TODO: We don't need this after POS-6890
            } finally {
                setLoading(false)
            }
        },
        [],
    )
    return {
        timeClock,
        loading,
        getCurrentUserTimeClock,
        saveActionOfUserTimeClock,
    }
}

export default useTimeClockState

export type IUseTimeClockState = ReturnType<typeof useTimeClockState>
